import { render, staticRenderFns } from "./dressup.vue?vue&type=template&id=91d2e2c8&scoped=true&"
import script from "./dressup.vue?vue&type=script&lang=js&"
export * from "./dressup.vue?vue&type=script&lang=js&"
import style0 from "./dressup.vue?vue&type=style&index=0&id=91d2e2c8&lang=scss&scoped=true&"
import style1 from "./dressup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d2e2c8",
  null
  
)

export default component.exports